import { useIntl } from 'react-intl';

import { Currency } from '../../types/currency';
import { Icon } from '../icons/Icon';
import styles from './NavigationHeader.module.less';

interface NavigationHeaderProps {
  currency: Currency;
  amount: string;
  period: number;
  onBack: () => void;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  currency,
  amount,
  period,
  onBack,
}) => {
  const intl = useIntl();

  const formattedAmount = intl.formatNumber(parseFloat(amount) || 0, {
    style: 'currency',
    currency: currency === 'USDC' || currency === 'USDT' ? 'USD' : currency,
    maximumFractionDigits: 0,
  });

  // For USDC/USDT, replace the locale-specific USD symbol (e.g. "$" or "US$") with the token name
  const displayAmount =
    currency === 'USDC' || currency === 'USDT'
      ? `${currency} ${intl.formatNumber(parseFloat(amount) || 0, { maximumFractionDigits: 0 })}`
      : formattedAmount;

  return (
    <div className={styles.navigationHeader}>
      <button className={styles.backButton} onClick={onBack} type="button">
        <Icon type="chevronDown" className={styles.backArrow} />
      </button>
      <span className={styles.headerText}>
        {intl.formatMessage({ id: 'form.currency.borrow' })} · <span className={styles.headerAmount}>{displayAmount}</span> · {intl.formatMessage({ id: 'form.period.monthsShort' }, { period })}
      </span>
    </div>
  );
};
